/**
 * SuccessMessage
 *
 * Final thank-you screen after upload completes, styled per survey theme.
 */
import React from 'react';
import { CheckCircle } from 'lucide-react';

export function SuccessMessage({ 
  campaign, 
  theme, 
  themes, 
  customTheme,
  getTextStyle,
  getSubtextStyle
}) {
  return (
    <div className="text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100 dark:bg-green-900/50">
        <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
      </div>
      <h2 className={`mt-4 text-2xl font-bold ${
        theme 
          ? theme === 'custom' ? 'text-white' : themes[theme]?.text || 'text-white'
          : 'text-gray-900 dark:text-white'
      }`} style={theme === 'custom' && getTextStyle ? getTextStyle() : {}}>
        Thank You!
      </h2>
      <p className={`mt-2 text-base ${
        theme 
          ? theme === 'custom' ? 'text-white/80' : themes[theme]?.subtext || 'text-white/80'
          : 'text-gray-600 dark:text-gray-400'
      }`} style={theme === 'custom' && getSubtextStyle ? getSubtextStyle() : {}}>
        Your video has been uploaded successfully. We appreciate your participation!
      </p>
      <p className={`mt-6 text-sm ${
        theme 
          ? theme === 'custom' ? 'text-white/60' : themes[theme]?.subtext || 'text-white/60'
          : 'text-gray-500 dark:text-gray-500'
      }`} style={theme === 'custom' && getSubtextStyle ? getSubtextStyle() : {}}>
        You may now close this window.
      </p>
    </div>
  );
}